import React from "react";

/**
 * "Powered by Digital Impressions" footer + credentials strip.
 *
 * Shown on the client_user portal pages as a subtle agency-brand reinforcement.
 * Uses the global /digital-impressions-logo.png + /di-credentials-strip.png
 * assets in /public so it loads instantly and stays consistent regardless of
 * per-client logo customisation on the hero.
 */
const DiBrandFooter = () => {
  return (
    <footer
      className="mt-12 mb-4 px-6 md:px-10"
      data-testid="di-brand-footer"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 24 }}
    >
      <div className="flex flex-col items-center gap-4 max-w-5xl mx-auto">
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] text-white/45">
          <span>Powered by</span>
          <img
            src="/digital-impressions-logo.png"
            alt="Digital Impressions"
            className="h-7 w-auto opacity-80"
            data-testid="di-footer-logo"
          />
        </div>
        <img
          src="/di-credentials-strip.png"
          alt="ISO 9001:2015 · 17 years · 100 team members · 1500+ projects · Shopify Plus Partner · Google Partner · Facebook Business Partner · Winner Excellence in Digital MKT"
          className="w-full max-w-4xl opacity-60 hover:opacity-80 transition-opacity"
          style={{ filter: "saturate(0.9)" }}
          data-testid="di-footer-credentials"
        />
        <div className="text-[10px] text-white/30 mt-1" data-testid="di-footer-copyright">
          © {new Date().getFullYear()} The Digital Impressions · All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default DiBrandFooter;
